import { Stack } from '@mantine/core';
import { RepeatStep } from '@/types/automationSteps.ts';
import StepCommonFields from '@/pages/Editor/components/SharedFields/StepCommonFields.tsx';
import RepeatFields from '@/pages/Editor/components/StepSidebar/StepForms/RepeatStep/RepeatFields.tsx';
import StepAdvancedConfigFields from '@/pages/Editor/components/SharedFields/StepAdvancedConfigFields.tsx';

type props = {
  step: RepeatStep;
};

export function RepeatForm({ step }: props) {
  // const noChildSteps = useStepSpecificError(step, StepErrorType.NoChildSteps);

  return (
    <Stack gap="md">
      <StepCommonFields step={step} nameLabel={'Step Name'} />
      {/*<SingleDataInputSelector step={step} parentSteps={parentSteps} />*/}
      {/*<Divider />*/}
      <RepeatFields step={step} />
      {/*<Divider />*/}
      {/*<Stack gap={0}>*/}
      {/*  /!*<StyledInputLabel>Children Steps</StyledInputLabel>*!/*/}
      {/*  {noChildSteps && (*/}
      {/*    <Flex mt={'-7px'} mb={'7px'}>*/}
      {/*      <StyledInputErrorText>{noChildSteps}</StyledInputErrorText>*/}
      {/*    </Flex>*/}
      {/*  )}*/}
      {/*  /!*<StepsRenderer steps={step.children} parentSteps={[step, ...parentSteps]} />*!/*/}
      {/*</Stack>*/}
      <StepAdvancedConfigFields step={step} />
    </Stack>
  );
}
